export const migrations = {
  1: (state) => {
    return {
      ...state,
      prefs: {
        ...state.prefs,
        smallDecimals: true,
      },
    };
  },
  2: (state) => {
    return {
      ...state,
      prefs: {
        ...state.prefs,
        windDirectionConvention: 'oceanographic',
      },
    };
  },
  3: (state) => {
    const {stationDetailList, ...weather} = state.weather;
    return {...state, weather};
  },
  4: (state) => {
    return {
      ...state,
      prefs: {
        ...state.prefs,
        lightningLayer: true,
      },
    };
  },
  // Mirror of mobile's migration 31. `user_data` reached the backend on
  // 2023-03-13 and nothing ever normalised the persisted `link`, so a station
  // stored before then rehydrates with a link object that has no such key —
  // which crashed the station list on mobile (SMARTMIXIN-IOS-6R). The webapp
  // persists `weather` to localStorage under the same shape and had no
  // equivalent heal, so the 2023 shape would have lived there indefinitely.
  // The read sites are guarded now; this stops the shape propagating. `{}` is
  // what the backend stores for a station with no user overrides.
  5: (state) => {
    const stationList = state.weather?.stationList;
    if (!Array.isArray(stationList)) {
      return state;
    }
    return {
      ...state,
      weather: {
        ...state.weather,
        stationList: stationList.map((station) =>
          station?.link && !station.link.user_data
            ? {...station, link: {...station.link, user_data: {}}}
            : station,
        ),
      },
    };
  },
};
